module.exports = __webpack_public_path__ + "img/logo05.3e6e74e0.png";